import {call, put, takeEvery} from 'redux-saga/effects';
import {
  MIGRATE_CLIENTS_REQUESTED,
  MIGRATE_DEALS_REQUESTED,
  SET_INDEX_CLIENTS_REQUESTED,
  SET_INDEX_DEALS_REQUESTED
} from "../actions/actionTypes";
import {messages} from "../../helpers/messages";
import {mcsIntegrationService} from "../../services/mcs-migrate-servise";
import {
  getMigrateClientsSuccess,
  getMigrateDealsSuccess,
  migrateFailed,
  openModalMigration,
  setIndexClientsSuccess,
  setIndexDealsSuccess
} from "../actions/mcsIntegrationAction";

const getMigrateClients = async () =>
  await mcsIntegrationService.getMigrateClients()
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const getMigrateDeals = async () =>
  await mcsIntegrationService.getMigrateDeals()
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const setIndexClients = async () =>
  await mcsIntegrationService.getIndexClients()
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const setIndexDeals = async () =>
  await mcsIntegrationService.getIndexDeals()
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

function* fetchGetMigrateClients() {
  try {
    const data = yield call(() => getMigrateClients())
    yield put(getMigrateClientsSuccess(data.data))
  } catch (error) {
    yield put(migrateFailed(error))
  }
  finally {
    yield put(openModalMigration(false))
  }
}

function* fetchGetMigrateDeals() {
  try {
    const data = yield call(() => getMigrateDeals())
    yield put(getMigrateDealsSuccess(data.data))
  } catch (error) {
    yield put(migrateFailed(error))
  }
  finally {
    yield put(openModalMigration(false))
  }
}

function* fetchSetIndexClients() {
  try {
    const data = yield call(() => setIndexClients())
    yield put(setIndexClientsSuccess(data.data))
  } catch (error) {
    yield put(migrateFailed(error))
  }
  finally {
    yield put(openModalMigration(false))
  }
}

function* fetchSetIndexDeals() {
  try {
    const data = yield call(() => setIndexDeals())
    yield put(setIndexDealsSuccess(data.data))
  } catch (error) {
    yield put(migrateFailed(error))
  }
  finally {
    yield put(openModalMigration(false))
  }
}

function* getMigrateClientsSaga() {
  yield takeEvery(MIGRATE_CLIENTS_REQUESTED, fetchGetMigrateClients)
}

function* getMigrateDealsSaga() {
  yield takeEvery(MIGRATE_DEALS_REQUESTED, fetchGetMigrateDeals)
}

function* setIndexClientsSaga() {
  yield takeEvery(SET_INDEX_CLIENTS_REQUESTED, fetchSetIndexClients)
}

function* setIndexDealsSaga() {
  yield takeEvery(SET_INDEX_DEALS_REQUESTED, fetchSetIndexDeals)
}
export {
  getMigrateClientsSaga,
  getMigrateDealsSaga,
  setIndexClientsSaga,
  setIndexDealsSaga

}
